module.exports = __webpack_public_path__ + "fedad6bd6d7060b5e7a874dfb44d1fa4.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/images/trickstrat/ts_icon.png
// module id = 158
// module chunks = 0